import {ReactElement} from "react"
import {Avatar} from "antd"
import {observer} from "mobx-react-lite"
import classNames from "classnames"
import {t} from "@ui/common/intl"
import {useStore} from "@ui/stores"

type TCategoryProps = {
  onSearch: () => void
}
const Category = ({onSearch}: TCategoryProps): ReactElement => {
  const {poi: {filter, categories}} = useStore()

  const handleClick = (code: typeof filter.params.spot_type) => {
    filter.change({spot_type: code})
    onSearch()
  }

  return (
    <div className="categories">
      {categories.map(({code}, i) => (
        <div
          key={`point-category-${i}`}
          className={classNames("category", {"selected": filter.params.spot_type === code})}
          onClick={() => handleClick(code)}
        >
          <Avatar src={`/poi/${code}.svg`} shape="circle" className={classNames("icon", code)} />
          <span className="title">{t(`poi.category.${code}`)}</span>
        </div>
      ))}
    </div>
  )
}

export default observer(Category)
